import { OrderProductId } from '../order';
import { TMEstimatorTemplateFeeId } from './TMEstimatorTemplateFeeResponse';
import { CategoryId, RangValue } from './TMItemCategoryResponse';

export type EstimatorTempateId = string;
export interface TmEstimatorTempateResponse {
  id: EstimatorTempateId;
  title: string;
  description: string;
  status: EstimatorTemplateStatus;
  type: EstimatorTemplateType;
  donotUseDefaultFormulas: boolean;
  feeIds: TMEstimatorTemplateFeeId[];
  formIds: string[];
  groups: EstimatorTemplateGroupResponse[];
}

export type CompactEstimatorTempateResponse = Pick<TmEstimatorTempateResponse, 'id' | 'title' | 'status' | 'type' | 'description' | 'formIds'>;

export type EstimatorTemplateGroupId = string;
export interface EstimatorTemplateGroupResponse {
  id: EstimatorTemplateGroupId;
  name: string;
  loPrice: number;
  hiPrice: number;
  range: RangValue;
  feeIds: TMEstimatorTemplateFeeId[];
  categoryTitle: string;
  markupFactor: number;
  categoryId: CategoryId;
  menuOrder: number;
  subGroups: EstimatorTemplateSubGroupResponse[];
  items: EstimatorTemplateItemResponse[];
}

export interface EstimatorTemplateSubGroupResponse {
  id: string;
  name: string;
  categoryId: string;
  menuOrder: number;
  items: EstimatorTemplateItemResponse[];
}

export enum EstimatorTemplateStatus {
  active = 1,
  deactivate = 0,
}

export enum EstimatorTemplateType {
  main = 'Main',
  subproject = 'Sub-Project',
}

export type EstimatorTemplateItemId = string;
export interface EstimatorTemplateItemResponse {
  id: EstimatorTemplateItemId;
  productId: OrderProductId;
  title: string;
  criteriaFormula: string;
  qtyFormula: string;
  markupFactor: number;
  unitPrice: number;
  feeIds: TMEstimatorTemplateFeeId[];
  salePrice: number;
  subCategoryId: CategoryId;
  menuOrder: number;
}

export enum SelectEstimateType {
  group = 0,
  category = 1,
}

export const SelectEstimateTypeItems = [SelectEstimateType.group, SelectEstimateType.category];
export const EstimateTemplateStatus = [EstimatorTemplateStatus.active, EstimatorTemplateStatus.deactivate];


export interface FormulaResponse {
  message: string;
  status: boolean
}
